import React from 'react';

// import HomeNoticeTab from './HomeNoticeTab';
// import HomeMyQueryReportTab from './HomeMyQueryReportTab';
// import HomeCarousel from '../../../container/carousel-home/HomeCarousel';
// import HomeTopTenTab from './HomeTopTenTab';

import './HomeMain.css';
import HomeNewsTopTenTab from './HomeNewsTopTenTab';
import HomeNoticeTab from './HomeNoticeTab';
import HomeYoutubeTopTenTab from './HomeYoutubeTopTenTab';
import NoticeModal from '../../modal/NoticeModal';


const HomeMain = (props) => {
  // const youtubePubDate=props.topTenData.youtubePubDate;
  // const youtubeTabContents=props.topTenData.youtubeTopTenData;
  // const youtubeCategory=props.topTenData.youtubeCategory;
  // const newsPubDate=props.topTenData.newsPubDate;
  // const newsTabContents=props.topTenData.newsTopTenData;
  // const noticeTabContents=props.noticeTabContents;
  // const handleViewMoreNotice=props.handleViewMoreNotice;

  return (
    <>
      <NoticeModal noticeShow={props.noticeShow} handleNoticeClose={props.handleNoticeClose} handleNoticeOff={props.handleNoticeOff}/>
      <div className="banner">
        <div className="bannertext-wrap">
          <div className="bannerText1">
            Audience is Everything®
          </div>
          <div className="bannerText2">
            Nielsen Media Korea의 buzzword 서비스는 국내 소셜미디어, 뉴스미디어, 상품평에서 생성된 텍스트 데이터를 수집, 분석하여<br />시장 현황 및 소비자의 니즈를 파악하고 마켓 인사이트를 발굴하는데 도움을 드립니다.
          </div>
        </div>
      </div>
      <div className="homeContent">
        <div className="row featured-home">
          {/* <HomeYoutubeTopTenTab youtubeCategory={youtubeCategory} youtubeTabContents={youtubeTabContents} youtubePubDate={youtubePubDate} />
          <HomeNewsTopTenTab newsPubDate={newsPubDate} newsTabContents={newsTabContents} />
          <HomeNoticeTab noticeTabContents={noticeTabContents} handleViewMoreNotice={handleViewMoreNotice} /> */}
          {props.topTenData&&<HomeYoutubeTopTenTab youtubeCategory={props.topTenData.youtubeCategory} youtubeTabContents={props.topTenData.youtubeTopTenData} youtubePubDate={props.topTenData.youtubePubDate} />}
          {props.topTenData&&<HomeNewsTopTenTab newsPubDate={props.topTenData.newsPubDate} newsTabContents={props.topTenData.newsTopTenData} />}
          {props.noticeTabContents&&<HomeNoticeTab noticeTabContents={props.noticeTabContents} handleViewMoreNotice={props.handleViewMoreNotice} />}
        </div>
      </div>
    </>
  )

  // return (
  //   <div>
  //     <table class="mainLayoutTb">
  //       <tr>
  //         <td valign="top" className="left">
  //           <div id="leftContent">
  //             <HomeTopTenTab youtubePubDate={youtubePubDate} youtubeCategory={youtubeCategory} youtubeTabContents={youtubeTabContents} newsPubDate={newsPubDate} newsTabContents={newsTabContents}/>
  //           </div>
  //         </td>
  //         <td valign="top" className="right">
  //           <div id="rightContent">
  //             <HomeCarousel bannerInfo={bannerInfo} />
  //             <HomeNoticeTab noticeTabContents={noticeTabContents} handleViewMoreNotice={handleViewMoreNotice}/>
  //             <HomeMyQueryReportTab queryTabContents={queryTabContents} reportTabContents={reportTabContents}/> 
  //           </div>
  //         </td>
  //       </tr>
  //     </table>
  //   </div>
  // )
}

export default HomeMain;

